import fi from "element-ui/src/locale/lang/fi";

const CommonUtil = {
  install(Vue) {
    /**
     * @return {string}
     */
    Vue.NumberWithCommas = function (x) {
      let parts = filterNumber(x);
      if (parts !== "") {
        parts = parts.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
      } else {
        return parts;
      }
    };

    Vue.FilterNumber = function(n) {
      return filterNumber(n);
    };

    let filterNumber = function (n) {
      return n.split(/ /)[0].replace(/[^\d]/g, '');
    };

    Vue.getBillingType = function(billing_type) {
      if(billing_type === 'D') {
        return "분납";
      } else if(billing_type === 'Y') {
        return "일시납";
      } else if(billing_type === 'M') {
        return "월납";
      } else {
        return "없음";
      }
    };

    Vue.getMediaType = function(media_type) {
      if(media_type === 'WC') {
        return "와이드칼라";
      } else {
        return "디지털미디어";
      }
    };
    Vue.getIsLight = function(isLight) {
      if(isLight) {
        return "조명";
      } else {
        return "비조명";
      }
    };
    /**
     * 기능 권한 확인
     * @param roleCode
     * @param targetRoles
     * @returns {boolean}
     */
    Vue.checkAuth = function (roleCode, targetRoles) {
      return targetRoles.indexOf(roleCode) >= 0;
    };

    /**
     * 권한 명 조회
     * @param roleCode
     */
    Vue.getRoleName = function (roleCode) {
      let roleName = "";
      switch (roleCode) {
        case "ADMIN":
          roleName = "관리자";
        break;
        case "MANAGER":
          roleName = "이마트 본사";
          break;
        case "ADVERTISER":
          roleName = "광고주";
          break;
        case "AGENT":
          roleName = "광고대행사";
          break;
        case "BUILDER":
          roleName = "시공사";
          break;
        case "EMART":
          roleName = "이마트 점포";
          break;
      }
      return roleName;
    }
  }
};

export default CommonUtil
